import React from 'react';
import { styled, TypographyVariant } from '@mui/material/styles';
import { ListItem, ListItemIcon, ListItemText, SvgIconProps } from "@mui/material";
import { Done } from '@mui/icons-material';
import classNames from 'classnames';

const PREFIX = 'CheckMarkListItem';

const classes = {
  itemText: `${PREFIX}-itemText`,
  iconGreen: `${PREFIX}-iconGreen`,
  list: `${PREFIX}-list`,
};

const StyledListItem = styled(ListItem)(({ theme }) => ({
  [`& .${classes.itemText}`]: { margin: 0, padding: 0 },
  [`& .${classes.iconGreen}`]: {
    color: theme.palette.valid,
    margin: theme.spacing(0, 0, 0, 0),
    fontSize: 12,
    minWidth: 28,
  },
  [`&.${classes.list}`]: {
    alignItems: 'flex-start',
    padding: theme.spacing(0, 1, 1, 1),
  },
}));

interface IProps {
  title: string;
  className?: string;
  iconFontSize?: SvgIconProps['fontSize'];
  textVariant?: TypographyVariant;
}

export const CheckMarkListItem = ({ title, className, iconFontSize, textVariant }: IProps) => {
  return (
    <StyledListItem className={classNames(classes.list, className)}>
      <ListItemIcon className={classes.iconGreen}>
        <Done fontSize={iconFontSize}  />
      </ListItemIcon>
      <ListItemText className={classes.itemText} primary={title} primaryTypographyProps={{ variant: textVariant }} />
    </StyledListItem>
  );
};
